import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Instagram, Facebook, Mail, Phone, MapPin } from 'lucide-react';

function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-warm-white border-t border-accent/30 py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <h3 className="font-playfair text-3xl font-medium text-charcoal mb-4">Casapooch</h3>
            <p className="text-muted-text mb-4">{t('footer.tagline')}</p>
            <div className="flex space-x-4">
              <a 
                href="https://instagram.com/lecasapooch" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-primary hover:text-charcoal transition-colors"
                data-testid="social-instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href="https://facebook.com/casapooch" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-primary hover:text-charcoal transition-colors"
                data-testid="social-facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-medium text-charcoal mb-4">{t('footer.quickLinks')}</h4>
            <nav className="flex flex-col space-y-2">
              <Link to="/" className="text-muted-text hover:text-primary transition-colors">{t('nav.home')}</Link>
              <Link to="/about" className="text-muted-text hover:text-primary transition-colors">{t('nav.about')}</Link>
              <Link to="/services" className="text-muted-text hover:text-primary transition-colors">{t('nav.services')}</Link>
              <Link to="/blog" className="text-muted-text hover:text-primary transition-colors">{t('nav.blog')}</Link>
              <Link to="/events" className="text-muted-text hover:text-primary transition-colors">{t('nav.events')}</Link>
              <Link to="/book" className="text-muted-text hover:text-primary transition-colors">{t('nav.book')}</Link>
              <Link to="/contact" className="text-muted-text hover:text-primary transition-colors">{t('nav.contact')}</Link>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-medium text-charcoal mb-4">{t('footer.contact')}</h4>
            <div className="flex flex-col space-y-3">
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-primary mt-0.5" />
                <span className="text-muted-text">{t('footer.addressLine1')}<br />{t('footer.addressLine2')}</span>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-primary" />
                <a href="tel:514-272-9016" className="text-muted-text hover:text-primary transition-colors">514-272-9016</a>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-primary" />
                <a href="mailto:woof@lecasapooch.com" className="text-muted-text hover:text-primary transition-colors">woof@lecasapooch.com</a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-accent/30 pt-8 text-center text-sm text-muted-text">
          <p data-testid="footer-rights">{t('footer.rights')}</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;